import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Hover guard: panels only respond after a REAL mouse movement.
// - Firefox applies :hover on page load to whatever sits under a parked cursor (Chrome waits for movement).
// - touchstart blocks sticky hover on touch devices; the next mousemove re-enables hover instantly.
window.addEventListener("touchstart", () => {
  document.documentElement.classList.add("is-touch");
}, { passive: true });
window.addEventListener("mousemove", () => {
  const h = document.documentElement;
  h.classList.add("has-mouse");
  h.classList.remove("is-touch");
}, { passive: true });

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
